import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AppInsightsService } from '../shared/services/appinsights/appinsights.service';
import { ConfigService } from '../shared/templates/Locale/locales.service';
import { LocaleComponent } from '../shared/templates/Locale/locale.component';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    imports: [LocaleComponent]
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  action: string;
  lang: string;
  view: string;
  constructor(private router: Router, private route: ActivatedRoute, private appInsightsService: AppInsightsService, private configService: ConfigService) { }

  ngOnInit() {
    this.appInsightsService.logPageView('ErrorPageComponent');  
    this.route.params
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(params => {
        this.action = params['action'];
        this.lang = params['lang'];
      });
    this.configService.languagerequested = this.lang;
    if (this.action.toLowerCase() === 'optout') {
      this.view = 'ERROR_OUT';
    }
    else {
      this.view = 'ERROR_IN';
    }
  }

  goBackToStart(): void {
    const action = this.action || 'all';
    this.router.navigateByUrl(`customer/${action}/${this.configService.languagerequested}`);
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
